import { SortDirection } from '@angular/material/sort';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { PAGE_SIZE_DEFAULT } from '../../_common/constants';
import { ShopListResponse, ShopModel } from './shop.model';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { BrandService } from '../brands/brand.service';

@Injectable({
  providedIn: 'root'
})

export class ShopService {

  constructor(private http: HttpClient,
    private toastr: ToastrService,
    private brandService: BrandService,
    @Inject('API_URL') private apiUrl: string
  ) { }  

  private shopComponentMethodCaller = new Subject<any>();
  componentMethodCalled$ = this.shopComponentMethodCaller.asObservable();

  callAddOrEditShopOpenDialog() {
    this.shopComponentMethodCaller.next();
  }

  getShops(pageIndex: number = 0, pageSize: number = PAGE_SIZE_DEFAULT, sortBy: string, sortDir: SortDirection, filter: any): Observable<ShopListResponse> {
    return this.http
      .get<ShopListResponse>(
        this.apiUrl + 'shop/shops',
        {
          params: new HttpParams()
            .set('sortBy', sortBy)
            .set('sortDir', sortDir)
            .set('pageNumber', pageIndex.toString())
            .set('pageSize', pageSize.toString())
            .set('filter', JSON.stringify(filter))
        }
      );
  }

  saveShop(shopModel: ShopModel): Observable<ShopModel> {
    return this.http
      .post<any>(this.apiUrl + 'shop/save', shopModel)
      .pipe(map(response => {
        if (response.error.message) {
          this.toastr.error(response.error.message);          
        }
        this.brandService.getBrandList();
        return response.model;
      })
    );
  }
}
